import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
    selector: 'ups-top-banner-broadcast',
    templateUrl: './top-banner-broadcast.component.html',
    styleUrls: ['./top-banner-broadcast.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TopBannerBroadcastComponent {
  @Input() broadcastMessage = '';
}
